import {useState} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {isInValidPassword, isValidEmail} from '../utils/handler';

interface ChangePasswordForm {
  currentPassword: string;
  password: string;
  confirmPassword: string;
}
export const ChangePassword: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  // let history = useHistory();
  const [userDetails, setUserDetails] = useState<ChangePasswordForm>({
    currentPassword: '',
    password: '',
    confirmPassword: '',
  });

  const [isFormValid, setIsFormValid] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const checkFormValid = () => {
    let { currentPassword = '', password = '', confirmPassword = '' } = userDetails;
    setFormSubmitted(true);
    if (!currentPassword) {
      return false;
    } else if (isValidEmail(currentPassword)) {
      return false;
    } else if (isInValidPassword(password)) {
      return false;
    } else if (password !== confirmPassword) {
      return false;
    }
    return true;
  };

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    // let { currentPassword = '', password = '', confirmPassword = '' } = userDetails;
    if (checkFormValid()) {
      // let payload = {
      //   currentPassword,
      //   password,
      //   confirmPassword,
      // };
    } else {
      setIsFormValid(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserDetails({
      ...userDetails,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="">
      <Helmet>
        <title>Change Password - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className="mt-2 ">
        <span className="sub-title ">{t('Change Password')} </span>
      </div>
      <form noValidate onSubmit={submit} className={'justify-content-between ' + (isFormValid || (formSubmitted && userDetails.password !== userDetails.confirmPassword) ? '' : ' was-validated')}>
        <div className="   ">
          <div className="form-group current-password">
            <label className="mt-2 fw-600">{t('Current Password')}</label>
            <div className=" form-group input-group">
              <input
                autoComplete="off"
                //  onPaste={(e) => { e.preventDefault(); return false }}
                type={showCurrentPassword ? 'text' : 'password'}
                className="form-control "
                name="currentPassword"
                value={userDetails.currentPassword}
                onChange={handleChange}
                placeholder="*******"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                required
              />
              {userDetails.currentPassword && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showCurrentPassword ? '' : '-slash')} onClick={() => setShowCurrentPassword(!showCurrentPassword)} aria-hidden="true"></i>}
              <div className="invalid-feedback">{t('passwordRule')}</div>
            </div>
          </div>
          <div className="form-group">
            <label className="mt-2 fw-600">{t('Password')}</label>
            <div className=" form-group input-group password-container">
              <input
                autoComplete="off"
                //  onPaste={(e) => { e.preventDefault(); return false }}
                type={showPassword ? 'text' : 'password'}
                className="form-control "
                name="password"
                value={userDetails.password}
                onChange={handleChange}
                placeholder="*******"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                required
              />
              {userDetails.password && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
              <div className="invalid-feedback">{t('passwordRule')}</div>
            </div>
          </div>
          <div className="form-group">
            <label className="mt-2 fw-600">{t('Confirm Password')}</label>
            <div className="input-group password-container">
              <input autoComplete="off" type="password" className={'form-control ' + (userDetails.password !== userDetails.confirmPassword ? ' is-invalid' : '')} name="confirmPassword" value={userDetails.confirmPassword} onChange={handleChange} placeholder="*******" pattern={userDetails.password !== userDetails.confirmPassword ? '' : undefined} required={userDetails.confirmPassword === ''} />
              <div className="invalid-feedback">{t('password and confirm password must match')}</div>
            </div>
          </div>
        </div>
        <div className="form-row justify-content-center">
          <button className="btn btn-grad" onClick={submit}>
            {t('Change Password')}
          </button>
        </div>
      </form>
    </div>
  );
};
